<template>
<span class="d-flex">
	<menu-icon
		name="station_lightnings"
		color="currentColor"
		edge-size="18"
		class="me-2"
	/>
	<template v-if="isLightningAboveStaion(eventPayload)">
		Блискавка над станцією
	</template>
	<template v-else>
		Блискавка, відстань {{ flashDistance(eventPayload)?.toFixed(2) }} км
	</template>
</span>
</template>



<script>
import MenuIcon from '@/components/Icons/MenuIcon.vue'
import { capitalizeFirstLetter } from '@/helpers.js'
import {
	eventSchema,
	isLightningAboveStaion,
	flashDistance,
 } from '@/composables/events.js'


export default {
	components: {
		MenuIcon,
	},
	
	props: {
		[eventSchema.payload.allowed.flashId.key]: {
			type: String,
			required: true,
		},
		[eventSchema.payload.allowed.flashTimeUTC.key]: {
			type: Date,
			required: true,
		},
		[eventSchema.payload.allowed.distanceKm.key]: {
			type: Number,
			required: true,
		},
		[eventSchema.payload.allowed.footprintRadiusKm.key]: {
			type: Number,
			required: true,
		},
	},

	setup() {
		return {
			capitalizeFirstLetter,
			eventSchema,
			isLightningAboveStaion,
			flashDistance,
		}
	},

	methods: {},

	computed: {
		eventPayload() {
			return this.$props
		},
	},
}
</script>